import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ensureAuthenticated } from './services/api';

const root = ReactDOM.createRoot(document.getElementById('root'));

function isMobileDevice() {
  if (typeof navigator === 'undefined') return false;

  const reportsMobile = navigator.userAgentData?.mobile === true;
  const mobileUserAgent = /Android|iPhone|iPad|iPod|IEMobile|BlackBerry|Opera Mini/i.test(
    navigator.userAgent || ''
  );
  const iPadDesktopMode = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

  return reportsMobile || mobileUserAgent || iPadDesktopMode;
}

function renderMobileAccessNotice() {
  root.render(
    <main style={{
      minHeight: '100vh',
      display: 'grid',
      placeItems: 'center',
      padding: 24,
      boxSizing: 'border-box',
      fontFamily: 'Montserrat, Inter, system-ui, sans-serif',
      color: '#111827',
      background: '#f6f7f9',
    }}>
      <div style={{ maxWidth: 440, textAlign: 'center' }}>
        <div style={{ color: '#16a34a', fontSize: 16, fontWeight: 800, marginBottom: 20 }}>
          Compass
        </div>
        <h1 style={{ margin: 0, fontSize: 28, lineHeight: 1.2 }}>
          Desktop access required
        </h1>
        <p style={{ margin: '14px 0 0', color: '#64748b', fontSize: 15, lineHeight: 1.6 }}>
          Compass is available on desktop browsers only. Please open this link on your work computer.
        </p>
      </div>
    </main>
  );
}

function renderStatus(message) {
  root.render(
    <div style={{
      minHeight: '100vh',
      display: 'grid',
      placeItems: 'center',
      fontFamily: 'Inter, system-ui, sans-serif',
      color: '#334155',
      background: '#f8fafc',
    }}>
      {message}
    </div>
  );
}

async function bootstrap() {
  if (isMobileDevice()) {
    renderMobileAccessNotice();
    return;
  }

  renderStatus('Signing in...');

  try {
    if (!await ensureAuthenticated()) return;

    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch (error) {
    console.error('Unable to verify authentication', error);
    renderStatus('Unable to connect. Please reload the page.');
  }
}

bootstrap();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
